module.exports = __webpack_public_path__ + "static/img/select-logo.0ee1b3b9.svg";